import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import { createMasterPolicy, editMasterPolicy, getMasterPolicyList } from "../../../services/ApiService";
import { api } from "../../../utils/api";
import { dataDisplayOptions, goBackPage, promptMessage } from "../../../utils/functions";
import { translate } from "../../../utils/translate";
import Select from 'react-select';
import { Col, Row } from "reactstrap";

const MasterPolicyForm = (props) => {
    const history = useHistory();
    const lang = props.lang;
    const displayTypeOptions = dataDisplayOptions(props.lang);
    const { type, slug } = useParams();
    const [queryParam, setQueryParam] = useState('');
    const [data, setData] = useState({
        name: "",
        key: "",
        displayType: "",
        icon: "",
    });
    const inputEl = useRef(null);
    const [file, setFile] = useState([]);
    const [error, setError] = useState({
        name: "",
        displayType: "",
        key: "",
    });

    useEffect(() => {
        const query = new URLSearchParams(props.location.search).toString();
        setQueryParam(query)
    }, []);

    useEffect(() => {
        if (type === 'create') {
            setData({
                name: "",
                displayType: "",
                key: "",
                icon: "",
            })
        } else if (type === 'view') {
            if (!slug) {
                history.push('/settings/master-policy');
                return;
            }
            getDetails(slug);
        } else if (type === 'edit') {
            if (!slug) {
                history.push('/settings/master-policy');
                return;
            }
            getDetails(slug);
        }
    }, [])

    const getDetails = async (slug) => {
        let params = { slug: slug };
        await getMasterPolicyList(params).then((response) => {
            const result = response.data[0];
            setData({
                id: result.id,
                name: result.name,
                key: result.key,
                displayType: result.dataDisplay,
                level: result.level,
                icon: result.icon,
            })
        }).catch((err) => {
            console.log(err);
            history.push('/settings/master-policy')
        })
    }

    const handleOptionSelected = (e, name) => {
        const { value } = e;
        const list = { ...data };
        list[name] = value;
        setData(list);
    }

    const onInputChange = (event) => {
        if (type === 'view') return;
        const { value, name } = event.target;
        let temp = data;
        temp[name] = value;
        setData({ ...temp });
    };

    const onFileChange = (event) => {
        setFile(event.target.files);
    };

    const submitForm = async () => {
        let check = true;
        let error = { name: "", displayType: "", key: "", file: "" };
        if (!data.name) {
            check = false;
            error.name = translate(lang, "errorRequired")
        }
        if (!data.key) {
            check = false;
            error.key = translate(lang, "errorRequired")
        }
        if (!data.displayType) {
            check = false;
            error.displayType = translate(lang, "errorRequired")
        }
        if (['create'].includes(type)) {
            if (!file || file.length < 1) {
                check = false;
                error.file = translate(lang, "errorRequired")
            }
        }
        setError({ ...error });
        if (check) {
            const formData = new FormData();
            formData.append("name", data.name);
            formData.append("key", data.key);
            formData.append("dataDisplay", data.displayType);
            if (file && file.length > 0) {
                for (let i = 0; i < file.length; i++) {
                    formData.append("attachments", file[i], file[i].name);
                }
            }
            if (type === 'create') {
                await createMasterPolicy(formData).then((res) => {
                    console.log(res.status)
                    if (res.status === 'success') {
                        promptMessage(lang, 'success', res.message)
                        history.push('/settings/master-policy');
                    } else {
                        promptMessage(lang, 'error', res.message)
                    }
                }).catch((error) => {
                    promptMessage(lang, 'error', error);
                })
            } else if (type === 'edit') {
                let id = data.id;
                delete data.id;
                await editMasterPolicy(formData, id).then((res) => {
                    if (res.status === 'success') {
                        promptMessage(lang, 'success', res.message)
                        history.push('/settings/master-policy');
                    } else {
                        promptMessage(lang, 'error', res.message)
                    }
                }).catch((error) => {
                    promptMessage(lang, 'error', error);
                })
            }
        }
    }


    return (
        <>
            <Row className="px-0 mx-0">
                <Col lg={6} md={6} sm={6} xs={6} className="mb-3">
                    <div className="d-flex align-items-center w-100 mb-4">
                        <div onClick={() => goBackPage('/settings/master-policy', queryParam)} className="cursor-pointer">
                            <div className="d-flex align-items-center">
                                <div className="back-btn">
                                    <i className="fas fa-chevron-left"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col lg={6} md={6} sm={6} xs={6} className="mb-3">
                    {type === 'view' ? (
                        <div className="d-flex w-100 justify-content-end">
                            <div onClick={() => goBackPage(`/settings/master-policy/edit/${slug}`, queryParam)} className="btn btn-sm btn-primary rounded-2 py-2" >{translate(lang, 'edit')}</div>
                            {/* <button className="btn btn-sm btn-primary" onClick={() => createMember()}>{translate(lang, 'createMember')}</button> */}
                        </div>
                    ) : null}
                </Col>
                <Col lg={12} md={12} sm={12} xs={12}>
                    <div className="card shadow col-12">
                        <div className="card-header">
                            <h3 className="m-0">
                                {translate(lang, (type === "view" ? "detailsMasterPolicy" : type === "edit" ? "editMasterPolicy" : "createMasterPolicy"))}
                            </h3>
                        </div>
                        <div className="card-body col-12 col-md-7 d-flex flex-column flex-wrap">
                            <div className="form-group py-2">
                                <label className="form-label required">{translate(lang, 'name')}</label>
                                <input type="text" name="name" value={data.name} onChange={(e) => onInputChange(e)} className="form-control mb-0" disabled={type === 'view' ? true : false} placeholder={type === 'view' ? "" : translate(lang, 'placeholderEnterHere')} />
                                {error.name !== "" ? <smalL className="text-danger">{error.name}</smalL> : <></>}
                            </div>
                            <div className="form-group py-2">
                                <label className="form-label required">{translate(lang, 'code')}</label>
                                <input type="text" name="key" value={data.key} onChange={(e) => onInputChange(e)} className="form-control mb-0" disabled={type === 'view' ? true : false} placeholder={type === 'view' ? "" : translate(lang, 'placeholderEnterHere')} />
                                {error.key !== "" ? <smalL className="text-danger">{error.key}</smalL> : <></>}
                            </div>
                            <div className="form-group py-2">
                                <label className="form-label required">{translate(lang, 'displayType')}</label>
                                <Select
                                    className="form-control mb-0"
                                    value={displayTypeOptions.filter(
                                        (option) => option.value === data.displayType
                                    )}
                                    isDisabled={type === 'view' ? true : false}
                                    onChange={(e) => handleOptionSelected(e, "displayType")}
                                    options={displayTypeOptions}
                                    placeholder={translate(lang, "placeholderChoose")}
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            height: "100%",
                                            border: 0,
                                            borderColor: "transparent",
                                            boxShadow: "none",
                                            "&:hover": {
                                                borderColor: "transparent",
                                                boxShadow: "none",
                                            },
                                            backgroundColor: "transparent",
                                        }),
                                        valueContainer: (base, state) => ({
                                            ...base,
                                            paddingLeft: 0,
                                            paddingRight: 0,
                                            borderColor: "transparent",
                                        })
                                    }}
                                />
                                {error.displayType !== "" ? <smalL className="text-danger">{error.displayType}</smalL> : <></>}
                                {/* <input type="text" value={data.displayType} onChange={(e) => { setData({ ...data, name: e.target.value }) }} className="form-control mb-0" disabled={type === 'view' ? true : false} placeholder={type === 'view' ? "" : translate(lang, 'placeholderEnterHere')} /> */}
                            </div>
                            {/* <div className="form-group py-2">
                        <label className="form-label">{translate(lang, 'level')}</label>
                        <input type="number" min="0" step="1" value={data.level} onChange={(e) => { setData({ ...data, level: e.target.value }) }} className="form-control mb-0" disabled={type === 'view' ? true : false} placeholder={type === 'view' ? "" : translate(lang, 'placeholderEnterHere')} />
                    </div> */}
                            <div className="py-2">
                                <div className="form-group" hidden={type === 'view' ? true : false}>
                                    <label className="form-label required">{translate(lang, 'icon')}</label>
                                    <input type="file" className="form-control h-100 mb-0" placeholder={type === 'view' ? "" : translate(lang, 'placeholderEnterHere')} onChange={(e) => onFileChange(e)} ref={inputEl} />
                                    {error.file !== "" ? <smalL className="text-danger">{error.file}</smalL> : <></>}
                                </div>
                                {type !== 'create' ? (<div className="mt-2">
                                    <label className="form-label">{translate(lang, 'currentIcon')}</label>
                                    <div className={`icon-box rounded-2`}>
                                        <img src={`${api.policyMasterIcon}/${data.icon}`} alt="logo" className="w-100 h-100 rounded-2" />
                                    </div>
                                </div>) : <></>}
                            </div>
                        </div>
                        <div className="card-footer">
                            <div className="d-flex flex-row">
                                <button type="button" hidden={type === 'view' ? true : false} className="btn btn-sm btn-primary rounded-2 py-2" onClick={() => submitForm()}>{translate(lang, `${type === 'edit' ? 'save' : type}`)}</button>
                                <button type="button" className="btn btn-sm btn-dark mx-2 rounded-2 py-2" onClick={() => goBackPage('/settings/master-policy', queryParam)}>{translate(lang, "back")}</button>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    )
}


const mapStateToProps = (state) => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
};


export default connect(mapStateToProps)(MasterPolicyForm);